module.exports = __webpack_public_path__ + "static/img/home_off.b93dd199.svg";